// this is to intercept all http requests
// the goal is to check for a 401 and then use a refresh token to refresh the access token

import {Injectable} from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import {from, Observable, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {OauthService} from './oauth.service';
import {SecureTokenService} from './secure-token.service';

@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {

    constructor(public router: Router, private _oauthServce: OauthService) {
    }

    /**
     * @func intercept
    * @async
    */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const token = SecureTokenService.getAccessToken();
        let authReq = req.clone({
            setHeaders: {
                'Cache-Control': 'no-cache, private',
                Pragma: 'no-cache'
            }
        });

        if (token && !authReq.headers.has('Authorization')) {
            authReq = authReq.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token
                }
            });
        }

        return next.handle(authReq).pipe(
            catchError((error) => {
                const isAuthFailure = error.status === 401 || error.status === 403;
                const isRefreshCall = req.url.includes('/uaa/oauth/refresh_token')
                    || req.url.includes('/sso/refresh_token');
                const alreadyRetried = req.headers.has('X-Retry-After-Refresh');

                if (!isAuthFailure || isRefreshCall || alreadyRetried) {
                    return throwError(error);
                }

                return from(this._oauthServce.refreshCurrentSessionToken()).pipe(
                    switchMap((refreshedToken) => {
                        if (!refreshedToken) {
                            this.router.navigate(['login']);
                            return throwError(error);
                        }

                        const retryReq = req.clone({
                            setHeaders: {
                                Authorization: 'Bearer ' + refreshedToken,
                                'X-Retry-After-Refresh': 'true'
                            }
                        });

                        return next.handle(retryReq);
                    }),
                    catchError((refreshError) => {
                        SecureTokenService.clearTokens();
                        sessionStorage.removeItem('username');
                        this.router.navigate(['login']);
                        return throwError(refreshError);
                    })
                );
            })
        );
    }
}
